import superChat from 'ai/reducers/superChat';
import sdnApi from 'ai/services/sdn';
import AddToBasketActions from 'actions/AddToBasketActions';
import LoveActions from 'actions/LoveActions';
import Authentication from 'utils/Authentication';
import {
    STD_BASKET_TYPE, PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT, PRODUCT_RECOMMENDATION_ANALYTICS_CATEGORY
} from 'ai/constants/superchat';
import { HEADER_VALUE } from 'constants/authentication';

const { feedback } = sdnApi;

const { ACTION_TYPES } = superChat;

const superChatActions = {
    showSuperChat: (showSuperChat, prompts, data) => {
        return {
            type: ACTION_TYPES.SHOW_SUPER_CHAT,
            payload: {
                showSuperChat,
                prompts,
                entryPointData: data
            }
        };
    },
    superChatConfig: (config) => {
        return {
            type: ACTION_TYPES.SUPER_CHAT_CONFIG,
            payload: config
        };
    },
    submitFeedback: async params => {
        const { question, response, sessionId, lastMessageId } = params || {};

        return feedback({ question, response, sessionId, lastMessageId }).then(data => data);
    },
    addToBasket: productData => {
        return dispatch => {
            const { skuList } = productData;
            const firstSku = skuList[0];

            const sku = {
                skuId: firstSku.skuId,
                productId: firstSku.productId
            };

            const basketType = STD_BASKET_TYPE;
            const qty = firstSku.qty || 1;
            const analyticsContext = PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT;
            const analyticsData = {
                productId: firstSku.productId,
                brandName: firstSku.brand_name,
                productName: firstSku.title,
                category: PRODUCT_RECOMMENDATION_ANALYTICS_CATEGORY
            };

            // Use the existing addToBasket action which handles all the basket state updates
            return dispatch(AddToBasketActions.addToBasket(
                sku,
                basketType,
                qty,
                null,
                analyticsContext,
                false, // samplePanel
                analyticsData,
                false, // showBasketQuickAdd
                false, // isAutoReplenish
                '', // replenishmentFrequency
                firstSku.productId
            ));
        };
    },
    addToLovesList: product => {
        return dispatch => {
            const analyticsData = {
                context: PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT,
                nextPageContext: PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT
            };

            // Check if user is logged in, if not show login modal
            return Authentication.requireAuthentication(null, null, analyticsData, null, false, HEADER_VALUE.USER_CLICK)
                .then(() => {
                    // User is authenticated, proceed with adding to love list
                    const skuLoveData = {
                        skuId: product.default_sku,
                        productId: product.id,
                        source: PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT,
                        loveSource: PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT
                    };

                    // Show the lists modal for the user to select which list to add to
                    dispatch(LoveActions.showMyListsModal(true));
                    dispatch(LoveActions.setSkuLoveData(skuLoveData));

                    // Set image data for the modal
                    const imageProps = {
                        id: product.default_sku,
                        skuImages: product.image_url ? [{ url: product.image_url }] : [],
                        disableLazyLoad: true,
                        altText: product.title
                    };
                    dispatch(LoveActions.setSkuLoveImageData(imageProps));
                })
                .catch(() => {
                    // User cancelled login or authentication failed
                    Sephora.logger.error('User cancelled login or authentication failed for love action');
                });
        };
    }
};

export default superChatActions;
